import {
  M8UserSortableField,
  M8PaginationParams,
} from 'services/production/types';
import { normalzieClientsTableSortableField } from 'services/production/utils/normalzieClientsTableSortableField';
import { TGetClientsPageDataParams } from 'types/services';

export const normalizeGetCleintsPageDataParams = (
  params: TGetClientsPageDataParams
) => ({
  toM8GetUsersParams(): M8PaginationParams<M8UserSortableField> {
    return {
      page: params.page - 1,
      size: params.pageSize,
      order: params.sorting.ascending ? 'ASC' : 'DESC',
      sort: normalzieClientsTableSortableField(
        params.sorting.field
      ).toM8UserSortableField(),
      startWith: params.searchBy || '',
    };
  },
});
